<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout align-center justify-center row>
              <v-avatar size="256" color="grey lighten-4">
                <img :src="imgSrc" alt="avatar" />
              </v-avatar>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['title', 'imgSrc', 'isOpen'],
  methods: {
    close() {
      this.$emit('onClose', false)
    },
  },
  mounted() {
    console.log('mounted', this.props)
  },
}
</script>

<style></style>
